import {LitElement, html} from 'lit-element';
import getRequestAsPromise from '@twebcomponents/web-components-common/js/xhttp/getRequestAsPromise.js';
import TranslationManager from '@twebcomponents/web-components-common/js/utilities/translationManager.js';
import addScrollToSiblingElement from '@twebcomponents/web-components-common/js/dom/addScrollToSiblingElement.js';

class AttachmentPicker extends LitElement {

    render() {
    return html`<div>
      <div style="display:none">
      {{COMPONENT_CSS}}
      </div>
      <div id="defaultStyles"></div>
      <div id="customStylesFromUrl"></div>      
      <div id="customStyles"></div>      
      
      ${this.stylesLoaded?html`
      ${!this.hideLaunchButton ? html`
      <button class="button primary reveal-overlay-link" @click=${this.showPickerDialog}>${this.tm.translate("launchButtonText")}</button>`:html``}
        <div class="reveal-overlay ${this.launchDialog?"show":""}">
          <div class="reveal-container">
            <div class="reveal">
                <header>
                    <h2>${this.tm.translate("componentTitle")}</h2>
                    <button class="button icon-circle icon-medium tertiary" @click=${this.close}>
                        <i class="icon-font tc-icon-content-close"></i>
                    </button>
                </header>
                <div class="scroll-section" id="scroll-section" @scroll=${(e) => addScrollToSiblingElement(e.target)}>
                    <ul class="tabs">
                        ${this.showFileFromConnect ? html`
                        <li class="tabs-title ${this.isShowFileFromConnect? 'active':''}" @click=${e=>this.setActiveTab("FILE_FROM_CONNECT")}>
                            <i class="icon-font tc-icon-explorer"></i>
                        </li>` : html``}   
                        ${this.show2DView || this.show3DView ? html`
                        <li class="tabs-title ${(this.isShowView) ? 'active':''}" @click=${e=>this.setActiveTab("VIEW")}>
                            <i class="icon-font tc-icon-views"></i>
                        </li>` : html``}   
                        ${this.showLink ? html`
                        <li class="tabs-title ${this.isShowLink? 'active':''}" @click=${e=>this.setActiveTab("LINK")}>
                            <i class="icon-font tc-icon-link"></i>
                        </li>` : html``}   
                        ${this.showFileFromComputer ? html`                                             
                        <li class="tabs-title ${this.isShowFileFromComputer? 'active':''}" @click=${e=>this.setActiveTab("FILE_FROM_COMPUTER")}>
                            <i class="icon-font tc-icon-laptop d-md-none"></i>
                            <i class="icon-font tc-icon-camera-alt hide d-lg-block"></i>
                        </li>` : html``}                                                  
                    </ul>
                        <div class="tabs-content">
                          ${this.showFileFromConnect ? html`
                          <div class="tabs-panel ${this.isShowFileFromConnect? 'active':''}">
                            <div class="row-center">
                                <button class="button tertiary icon-medium icon-circle ${this.getParentId(this.currentFolderId)?'':'hide'}" @click=${e => this.reloadFileList(this.getParentId(this.currentFolderId))}>
                                    <i class="icon-font tc-icon-arrow-line-back"></i>
                                </button>
                                <h4>${this.getFolderName(this.currentFolderId)}</h4>                               
                            </div>
                            ${this.loadingFiles ? html`
                            <section class="scrolling-content vertical-center">
                              <div class="row-center">
                                <i class="icon-font tc-icon-spinner-dark"></i>&nbsp;<p class="text-muted">${this.tm.translate("loadingFiles")}</p>
                              </div>                              
                            </section>` : html``}
                            ${!this.loadingFiles && !this.listOfFiles.length ? html`
                            <section class="scrolling-content vertical-center">
                              <div class="empty small">
                                <div class="empty-icon">
                                  <i class="icon-font tc-icon-folder"></i>
                                </div>
                                <div class="empty-text">                                                                                
                                  <p class="text-muted">${this.tm.translate("folderEmpty")}</p>
                                </div>                                   
                              </div>
                              <div>
                              </div>
                            </section>` : html``}
                            ${this.listOfFiles.length ? html`
                            <section class="scrolling-content" @scroll=${e=>this.loadFiles()}>
                              <ul class="list">
                                ${this.listOfFiles.map((item,i) => this.getFileTemplate(item))}
                              </ul>
                            </section>` : html``}
                        </div>` : html``}   
                        ${this.show2DView || this.show3DView ? html`
                        <div class="tabs-panel ${this.isShowView? 'active':''}">
                            <div class="row-distribute">
                                <div><h4>${this.tm.translate("views")}</h4></div>
                                <div class="toggle-button-group">
                                    ${this.show3DView ? html`
                                    <button class="button small light  ${(this.isShow3DView) ? 'active':''}" @click=${e=>this.setActiveViewTab("3D_VIEW")}>${this.tm.translate("view3D")}</button>
                                    ` : html``}
                                    ${this.show2DView ? html`
                                    <button class="button small light  ${(this.isShow2DView) ? 'active':''}" @click=${e=>this.setActiveViewTab("2D_VIEW")}>${this.tm.translate("view2D")}</button>                                  
                                    ` : html``}
                                </div>
                            </div>     
                            ${this.show3DView && this.isShow3DView && this.loading3DViews ? html`
                            <section class="scrolling-content vertical-center">
                                <div class="row-center">
                                    <i class="icon-font tc-icon-spinner-dark"></i>&nbsp;<p class="text-muted">${this.tm.translate("loading3DViews")}</p>
                                </div>
                           </section>` : html``}
                           ${this.show3DView && this.isShow3DView && !this.loading3DViews && !this.listOf3DViews.length ? html`
                           <section class="scrolling-content vertical-center">
                                <div class="empty small">
                                    <div class="empty-icon">
                                        <i class="icon-font tc-icon-views"></i>
                                    </div>
                                    <div class="empty-text">                                                                                
                                        <p class="text-muted">${this.tm.translate("no3DViews")}</p>
                                    </div>                                   
                                </div>
                                <div>
                                    
                                </div>
                           </section>` : html``}              
                           ${this.show3DView && this.isShow3DView && this.listOf3DViews.length ? html` 
                            <section class="scrolling-content">                                                             
                                <ul class="list">
                                  ${this.listOf3DViews.map((item,i) => this.getViewTemplate(item, '3D_VIEW'))}
                                </ul>
                            </section>` : html``}

                            ${this.show2DView && this.isShow2DView && this.loading2DViews ? html`
                            <section class="scrolling-content vertical-center">
                              <div class="row-center">
                                <i class="icon-font tc-icon-spinner-dark"></i>&nbsp;<p class="text-muted">${this.tm.translate("loading2DViews")}</p>
                              </div>
                           </section>` : html``}
                           ${this.show2DView && this.isShow2DView && !this.loading2DViews && !this.listOf2DViews.length ? html`
                           <section class="scrolling-content vertical-center">
                                <div class="empty small">
                                    <div class="empty-icon">
                                        <i class="icon-font tc-icon-views"></i>
                                    </div>
                                    <div class="empty-text">                                                                                
                                        <p class="text-muted">${this.tm.translate("no2DViews")}</p>
                                    </div>                                   
                                </div>
                                <div>
                                    
                                </div>
                           </section>` : html``}              
                           ${this.show2DView && this.isShow2DView && this.listOf2DViews.length ? html` 
                            <section class="scrolling-content">                                                             
                                <ul class="list">
                                  ${this.listOf2DViews.map((item,i) => this.getViewTemplate(item, '2D_VIEW'))}
                                </ul>
                            </section>` : html`` }
                        </div>` : html``}   
                        ${this.showLink ? html`
                        <div class="tabs-panel ${this.isShowLink? 'active':''}">
                            <div class="input-group">
                                <label>${this.tm.translate("linkText")}</label>
                                <div class="input-focus-group">
                                    <input type="text" id="link_text" placeholder="" class="${this.linkTextError ? 'error': ''}" @keyup=${this.linkTextChanged} />
                                    <div class="line"></div>
                                </div>
                                ${this.linkTextError ? html`<label class="error-message">${this.tm.translate("linkTextError")}</label>` : html ``}
                            </div>
                            <div class="input-group">
                                <label>${this.tm.translate("linkUrl")}</label>
                                <div class="input-focus-group">
                                    <input type="text" id="link_url" placeholder="https://www.example.com" class="${this.linkUrlError ? 'error': ''}" @keyup=${this.linkUrlChanged}/>
                                    <div class="line"></div>
                                </div>                                
                                ${this.linkUrlError ? html`<label class="error-message">${this.tm.translate("linkUrlError")}</label>` : html ``}
                            </div>                            
                        </div>` : html``}   
                        ${this.showFileFromComputer ? html`                        
                        <div class="tabs-panel ${this.isShowFileFromComputer? 'active':''}">
                          ${this.shortlistedComputerFile? html`
                          <div class="row-center">                                
                                <h4>${this.tm.translate("selectedFile")}</h4>                               
                          </div> 
                          <section class="scrolling-content">
                          <ul class="list">
                          <li class="list-item group">
                            <div class="group-items bg-white">
                              <div>
                              <i class="icon-font tc-icon-file"></i>
                              </div>  
                              <div class="block text">
                              ${this.shortlistedComputerFile.name}
                              </div>
                              <button class="button icon-circle icon-medium tertiary" @click=${this.clearShortlistedComputerFile}>
                                    <i class="icon-font tc-icon-content-close"></i>
                              </button>
                           </div> 
                          </li>
                          </ul>
                          </section>` : html`
                            <small class="text-muted">
                            ${this.tm.translate("fileLimitMessage")}
                            </small>
                            <section style="display:none">
                              <input id="browsed_file" type="file" class="button secondary" @change=${this.computerFileSelectionChanged} />
                            </section>
                            <section class="file-upload-section d-md-none">
                                <div class="droppable ${this.onDropTarget ? 'active' : (this.multipleComputerFilesSelected || this.nonFileSelected ? 'error' : '')}" id="dropped_file" @drop=${e => this.dropHandler(e)} @dragover=${e => this.dragOverHandler(e)} @dragenter=${e => this.dragEnterHandler(e)} @dragleave=${e => this.dragLeaveHandler(e)}>
                                    ${this.multipleComputerFilesSelected || this.nonFileSelected ? html`
                                    <!-- Icon for error state -->
                                    <i class="icon-font tc-icon-block"></i>
                                    <!-- Text to show in error -->
                                    ${this.nonFileSelected ? this.tm.translate("nonFileSelectedError") : this.tm.translate("fileLimitError")}` : html`
                                    <i class="icon-font tc-icon-file"></i>
                                    ${this.tm.translate("dragDropMessage")}`}
                                </div>
                                <h6 class="text-muted">${this.tm.translate("or")}</h6>
                               <button class="button secondary" @click=${this.launchNativeBrowser}>${this.tm.translate("browse")}</button>                                   
                            </section>  
                            <section class="file-upload-section vertical-center hide d-lg-block">
                                <button class="button secondary" @click=${this.launchNativeBrowser}>${this.tm.translate("browseDevice")}</button>
                            </section>`}                                                                                   
                        </div>` : html``}
                    </div>
                  </div>                            
                <footer>
                    <hr>
                    <div class="wrap-buttons">
                        <a class="button link-secondary" @click=${this.close}>${this.tm.translate("cancel")}</a>
                        <button class="button primary" ?disabled=${this.isShortlistedItemAvailbleForSelection() == false} @click=${this.selectObject}>${this.tm.translate("submit")}</button>
                    </div>
                </footer>                
              </div>
          </div>
      </div>

                          `:html`<div><i class="tc-icon-spinner-dark"></i></div>`}
                          </div> 
      `;
  }

  getFileTemplate(item){
    return html`<li class="list-item group" @click=${e => this.handleFileClick(item, e)}>
    <div class="group-items bg-white selectable ${this.isShortlistedItem(item, 'FILE_FROM_CONNECT')?'active':''}">
        <div>
            ${item.type == 'FOLDER' ? html`
            <i class="icon-font tc-icon-folder"></i>`: html`${item.thumbnailUrl && item.thumbnailUrl.length ?
            html`<div class="image-thumbnail small" style="background-image:url(${item.thumbnailUrl[0]})"></div>`:
            html`<i class="icon-font tc-icon-file"></i>`}
            `}
        </div>
        <div class="block text">
            ${item.name}
        </div>
        ${item.type == 'FOLDER' ? html`<i class="icon-font tc-icon-chevron-right icon-right"></i>` : html``}
    </div>
    </li>`
  }

  getViewTemplate(item, type){
    return html`<li class="list-item group" @click=${e => this.toggleShortlistedItem(item, type)}>
    <div class="group-items bg-white selectable ${this.isShortlistedItem(item, type)?'active':''}">
        <div>
        <div class="image-thumbnail small" style="background-image:url(${this.appendAccessToken(item.thumbnail)})"></div>
        </div>
        <div>
            ${item.name}
        </div>
    </div>
    </li>`
  }

  static get properties() {
    return {
      /* accessToken: Bearer token being passed in the api call (get object list) */
      accessToken: {
        type: String,
        attribute: 'access-token',
        reflect: false
      },
      /* TwoDimensionalViewListApiUrl: Api url for fetching 2d view list */
      TwoDimensionalViewListApiUrl: {
        type: String,
        attribute: 'two-dimensional-view-list-api-url',
        reflect: false
      },
      /* ThreeDimensionalViewListApiUrl: Api url for fetching 3d view list */
      ThreeDimensionalViewListApiUrl: {
        type: String,
        attribute: 'three-dimensional-view-list-api-url',
        reflect: false
      },
      /* folderDetailApiUrl: Api url for fetching details with a placeholder for folderId. The placeholder should be ''<<folderId>>'. This will be used to fetch path (breadcrumb) information which will be used to show parent folder name and allow to go back to parent folder */
      folderDetailApiUrl: {
        type: String,
        attribute: 'folder-detail-api-url',
        reflect: false
      },
      /* fileListApiUrl: Api url for fetching children(file/folder) list with a placeholder for folderId (connect folder) whose contents needs to be listed. The placeholder should be ''<<folderId>>'. Initially, the placeholder '<<folderId>>' will be replaced by the value of folderId property provided by the user. Later on, folderId will be decided based on the user actions such as clicking on the folder (connect folder) within the component */
      fileListApiUrl: {
        type: String,
        attribute: 'file-list-api-url',
        reflect: false
      },
      /* folderId: Initial value for folderId which will replace '<<folderId>>' placeholder in folderDetailApiUrl & fileListApiUrl */
      folderId: {
        type: String,
        attribute: 'folder-id',
        reflect: false
      },
      /* allowedAttachmentTypes: list of Tabs to display. Provide list of types separated by comma. Valid values in the list are '2D_VIEW','3D_VIEW', 'FILE_FROM_CONNECT', 'FILE_FROM_COMPUTER', 'LINK' AND 'ALL'. Default is 'ALL' */
      allowedAttachmentTypes: {
        type: String,
        attribute: 'allowed-attachment-types',
        reflect: false
      },
      /* translationSource: To provide an array of translation sources. Each item in the list can either be a translation url or a translation dictionary. For example, the translation source can be defined as below.
      var translationUrl = "translations.json";

      var translationDictionary = {
      "componentTitle1": "Object picker",
      "launchButtonText": "Select",
      "browseDevice": "Browse device photos",
      "submit1": "Select"
      };


      var translationSource = [
        {
            "type": "URL",
            "value": translationUrl
        },
        {
            "type": "DICTIONARY",
            "value": translationDictionary
        }
      ];
      */
      translationSource: {
        type: Object,
        attribute: "translation-source",
        reflect: false
      },
      /* translationKeyMap: To provide translation 'custom translation key' - 'default translation key' mapping. This is useful when the component's translation key is different from the one mentioned in the cutome translation key */
      translationKeyMap: {
        type: Object,
        attribute: "translation-key-map",
        reflect: false
      },
      /* customStyleUrl: To provide custom stylesheet url */
      customStyleUrl: { 
        type: String,
        attribute: "custom-style-url",
        reflect: false
      },
      /* customStyle: To provide custom style */
      customStyle: { 
        type: String,
        attribute: "custom-style",
        reflect: false
      },
      /* hideLaunchButton: add this attribute if you want to hide the default launch button */
      hideLaunchButton: { 
        type: Boolean,
        attribute: "hide-launch-button",
        reflect: true
      },
      /* launchDialog: add this attribute if you want to launch the attachment picker dialog */
      launchDialog: { 
        type: Boolean,
        attribute: "launch-dialog",
        reflect: true
      }
    };
  }

  constructor(defaultAttributes) {
    super();
    console.log("api url:", this.apiUrl);
    this.componentName = 'attachment-picker';
    this.accessToken = "";
    
    this.folderDetailApiUrl = "";
    this.fileListApiUrl = "";
    this.folderId = "";
    this.TwoDimensionalViewListApiUrl = "";
    this.ThreeDimensionalViewListApiUrl = "";
    this.allowedAttachmentTypes = "";

    this.selection = null;

    this.translationSource = [];
    this.translationKeyMap = {};
    this.customStyle = '';
    this.customStyleUrl = '';
    this.hideLaunchButton = false;
    this.launchDialog = false;

    this.loadingFiles = false;
    this.loading2DViews = false;
    this.loading3DViews = false;
    this.pageSize = 25;

    this.endOfFiles = false;
    this.endOf2DViews = false;
    this.endOf3DViews = false;

    this.defaultTranslationDictionary = {
      "componentTitle": "Add attachment",
      "launchButtonText": "Add attachment",
      "loadingFiles": "Loading files",
      "folderEmpty": "There are no files in this folder.",
      "views": "Views",
      "view3D": "3D",
      "view2D": "2D",
      "loading3DViews": "Loading 3D Views",
      "no3DViews": "There are no 3D Views",
      "loading2DViews": "Loading 2D Views",
      "no2DViews": "There are no 2D Views",
      "linkText": "Display text",
      "linkTextError": "Please enter display text",
      "linkUrl": "Web URL",
      "linkUrlError": "Please enter valid URL",
      "selectedFile": "Selected file",
      "fileLimitMessage": "You can only attach one file at a time.",
      "fileLimitError": "Only one file can be attached at a time",
      "nonFileSelectedError": "Folders cannot be attached. Only a single file can be attached at one time.",
      "dragDropMessage": "Drag and drop a file here",
      "or": "- OR -",
      "browse": "Browse",
      "browseDevice": "Browse device photos",
      "submit": "Add",
      "cancel": "Cancel"
    };
    this.stylesLoaded = false;

    this.showFileFromConnect = false;
    this.show2DView = false;
    this.show3DView = false;
    this.showFileFromComputer = false;
    this.showLink = false;

    this.placeHolderPattern = "<<folderId>>";

    this.listOfFiles = [];
    this.listOf2DViews = [];
    this.listOf3DViews = [];

    this.currentFolderId = null;
    this.currentFileListApiUrl = '';
    this.folders = []; //this holds the list of recently visited folders
    this.shortlistedConnectFile = null;
    this.shortlisted2DView = null;
    this.shortlisted3DView = null;
    this.shortlistedLink = null;
    this.shortlistedComputerFile = null;

    this.multipleComputerFilesSelected = false;
    this.nonFileSelected = false;
    this.linkTextError = false;
    this.linkUrlError = false;
    this.linkText = "";
    this.linkUrl = "";

    this.tm = new TranslationManager(null, null, this.defaultTranslationDictionary);

    defaultAttributes = defaultAttributes || {};
    Object.keys(defaultAttributes).forEach(function(attrKey){
      if( defaultAttributes[attrKey] != null ) {
        this.setAttribute(attrKey, defaultAttributes[attrKey]);
      }
    }.bind(this));
  }
  
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("on-window-resize", function(e){
      this.dispatchEvent(new CustomEvent('on-container-height-changed', {detail: {}}));
    }.bind(this));
    this.dispatchEvent(new CustomEvent('on-component-ready', {detail: {source: "user-picker"}}));

    this.getStyles();

    this.getCustomStyles();
    this.setAttachmentVisibility();
    this.setActiveTab();
    this.setActiveViewTab();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if(newValue && newValue != 'null' && newValue.indexOf('{{') == -1){
      this.accessToken = (name == 'access-token')? newValue : this.accessToken;
      this.TwoDimensionalViewListApiUrl = (name == 'two-dimensional-view-list-api-url')? newValue : this.TwoDimensionalViewListApiUrl;
      this.ThreeDimensionalViewListApiUrl = (name == 'three-dimensional-view-list-api-url')? newValue : this.ThreeDimensionalViewListApiUrl;
      this.folderDetailApiUrl = (name == 'folder-detail-api-url')? newValue : this.folderDetailApiUrl;
      this.fileListApiUrl = (name == 'file-list-api-url')? newValue : this.fileListApiUrl;
      this.folderId = (name == 'folder-id')? newValue : this.folderId;
      this.allowedAttachmentTypes = (name == 'allowed-attachment-types')? newValue : this.allowedAttachmentTypes;

      this.translationSource = (name == 'translation-source')? (newValue ? this.parseJSON(newValue, []) : []) : this.translationSource;
      this.translationKeyMap = (name == 'translation-key-map')? (this.isNonEmptyObject(this.parseJSON(newValue, {})) ? this.parseJSON(newValue, {}) : {}) : this.translationKeyMap;

      this.customStyleUrl = (name == 'custom-style-url')? newValue : this.customStyleUrl;
      this.customStyle = (name == 'custom-style')? newValue : this.customStyle;
      this.hideLaunchButton = (name == 'hide-launch-button')? (this.parseJSON(newValue, false) === true ? true : false) : this.hideLaunchButton;
      this.launchDialog = (name == 'launch-dialog')? (this.parseJSON(newValue, false) === true ? true : false) : this.launchDialog;

      if( (name == 'two-dimensional-view-list-api-url' || name == 'access-token') && this.accessToken && this.TwoDimensionalViewListApiUrl){
        if(!this.loading2DViews){
          this.load2DViews();
        }
      } 

      if( (name == 'three-dimensional-view-list-api-url' || name == 'access-token') && this.accessToken && this.ThreeDimensionalViewListApiUrl){
        if(!this.loading3DViews){
          this.load3DViews();
        }
      } 

      if ((name == 'folder-detail-api-url' || name == 'access-token' || name == 'folder-id') && this.accessToken && this.folderDetailApiUrl && this.folderId) {
        this.currentFolderId = this.folderId;
        this.loadFolderDetails(this.folderId);
      }

      if (!this.loadingFiles) {
        if ((name == 'file-list-api-url' || name == 'access-token' || name == 'folder-id') && this.accessToken && this.fileListApiUrl && this.folderId) {
          this.reloadFileList(this.folderId);
        }
      }

      if(name == "translation-source"){
        this.tm.setTranslationSource(this.translationSource);
      }
      if(name == "translation-key-map"){
        this.tm.setTranslationKeyMap(this.translationKeyMap);
      }

      this.requestUpdate();
    }
  }

  parseJSON(value, defaultValueOnParseFailure){
    var result = null;
    if (typeof value === "object") {
      result = value;
    } else {
      try {
        result = JSON.parse(value);
      }
      catch (err) {
        if(defaultValueOnParseFailure){
          result = defaultValueOnParseFailure;
        }else{
          throw err;
        }
      }
    }

    return result;
  }

  //To reset al the selections made during lasttime the picker was launched
  resetSelections(){
    this.setAttachmentVisibility();
    this.setActiveTab();
    this.setActiveViewTab();
    this.clearShortlist();
    this.clearLinkForm();
    this.clearFileUploadErrors();
    this.requestUpdate();
  }

  clearLinkForm(){
    this.shadowRoot.querySelector("#link_text") && (this.shadowRoot.querySelector("#link_text").value = "");
    this.shadowRoot.querySelector("#link_url") && (this.shadowRoot.querySelector("#link_url").value = "");
    this.linkTextError = false;
    this.linkUrlError = false;
    this.requestUpdate();
  }

  clearFileUploadErrors(){
    this.multipleComputerFilesSelected = false;
    this.nonFileSelected = false;
  }

  close(){
    this.launchDialog = false;
    this.dispatchEvent(new CustomEvent('closed', { detail: { source: "attachment-picker", data: 'CLOSED' } }));
    this.requestUpdate();
  }

  selectObject(){
    var result = null;

    if(this.isShowFileFromConnect){
      result = {
        'selectedObject':this.shortlistedConnectFile,
        'type':'FILE_FROM_CONNECT'
      };
    }else if(this.isShowView && this.isShow2DView){
      result = {
        'selectedObject':this.shortlisted2DView,
        'type':'2D_VIEW'
      };
    }else if(this.isShowView && this.isShow3DView){
      result = {
        'selectedObject':this.shortlisted3DView,
        'type':'3D_VIEW'
      };
    }else if(this.isShowLink){
      result = {
        'selectedObject':this.shortlistedLink,
        'type':'LINK'
      };
    }else if(this.isShowFileFromComputer){
      result = {
        'selectedObject':this.shortlistedComputerFile,
        'type':'FILE_FROM_COMPUTER'
      };
    }

    this.dispatchEvent(new CustomEvent('object-selected', {detail: {source: "attachment-picker", data: result}}));
    this.close();
  }

  clearShortlist(){
    this.shortlistedConnectFile = null;
    this.shortlisted2DView = null;
    this.shortlisted3DView = null;
    this.shortlistedLink = null;
    this.shortlistedComputerFile = null;
    this.requestUpdate();
  }

  isShortlistedItemAvailbleForSelection(){
    var result = false;

    if(this.isShowFileFromConnect && this.shortlistedConnectFile){
      result = true;
    }else if(this.isShowView && this.isShow2DView && this.shortlisted2DView){
      result = true;
    }else if(this.isShowView && this.isShow3DView && this.shortlisted3DView){
      result = true;
    }else if(this.isShowLink && this.shortlistedLink){
      result = true;
    }else if(this.isShowFileFromComputer && this.shortlistedComputerFile){
      result = true;
    }
    console.log("isShortlistedItemAvailbleForSelection = ", result);
    return result;
  }

  resetFileList(){
    this.loadingFiles = false;
    this.endOfFiles = false;
    this.listOfFiles = [];
  }  
  
  setFileListApiUrl(folderId){
    var result = this.fileListApiUrl;
    result = result.replace(this.placeHolderPattern, folderId);
    this.currentFileListApiUrl = result;
  }

  reloadFileList(folderId){
    if(this.loadingFiles){
      console.log("previous file list call is still in progress");
      return;
    }else if(!folderId){
      console.log("root folder reached or no folder id provided");
      return;
    }else{
      this.resetFileList();
      this.setFileListApiUrl(folderId);
      this.currentFolderId = folderId;
      this.loadFiles();
    }
  }

  async loadFolderDetails(folderId) {
    this.folders = this.folders || [];

    //check if the folder detail is already available
    var matchingFolders = this.folders.filter(f => f.id == folderId);
    if (!matchingFolders.length) {
      var currentfolderDetailApiUrl = this.folderDetailApiUrl;
      currentfolderDetailApiUrl = currentfolderDetailApiUrl.replace(this.placeHolderPattern, folderId);
      
      var res = await this.getDetail(currentfolderDetailApiUrl, this.accessToken);
      let f1 = JSON.parse(res);
      //again check if the folder detail is already available
      let matchingFolders2 = this.folders.filter(f => f.id == f1.id);
      if (!matchingFolders2.length) {
        this.folders.push(f1);
        console.log("this.folders=", this.folders);
      }
      this.requestUpdate();
    }
  }

  addToFolders(folder) {
    var index = -1;
    for(var i=0;i<this.folders.length;i++){
      if(this.folders[i].id == folder.id){
        index = i;
        break;
      }
    }

    if(index != -1){
      this.folders[index] = folder;
    }else{
      this.folders.push(folder);
    }
    console.log("this.folders1 = ", this.folders);
  }

  getFolderDetail(folderId, retryCount){
    var matchingFolders = this.folders.filter(f => f.id == folderId);
    if (matchingFolders.length) {
      return matchingFolders[0];
    }else{
      retryCount = retryCount || 0;
      if(retryCount > 0){
        this.loadFolderDetails(folderId);
        return this.getFolderDetail(folderId, retryCount - 1);
      }else{
        return null;
      }
    }
  }

  getFolderName(folderId){
    var f = this.getFolderDetail(folderId, 1);
    console.log("getFolderName = ", f);
    return f && f.name ? f.name : '';
  }

  getParentId(folderId){
    var parentId = null;
    var f = this.getFolderDetail(folderId);
    parentId = f && f.path && f.path.length ? f.path[f.path.length-1].id : null;

    return parentId;
  }

  setAttachmentVisibility(){
    var types = ["ALL"];
    if(this.allowedAttachmentTypes){
      types = this.allowedAttachmentTypes.split(",");
    }

    if(types.indexOf("ALL") > -1){
      this.show2DView = true;
      this.show3DView = true;
      this.showFileFromConnect = true;
      this.showFileFromComputer = true;
      this.showLink = true;
    }else{
      this.show2DView = types.indexOf("2D_VIEW") > -1;
      this.show3DView = types.indexOf("3D_VIEW") > -1;
      this.showFileFromConnect = types.indexOf("FILE_FROM_CONNECT") > -1;
      this.showFileFromComputer = types.indexOf("FILE_FROM_COMPUTER") > -1;
      this.showLink = types.indexOf("LINK") > -1;
    }

    console.log("--------------Inside setAttachmentVisibility-------------");
    console.log("this.show2DView = ", this.show2DView);
    console.log("this.show3DView = ", this.show3DView);
    console.log("this.showFileFromConnect = ", this.showFileFromConnect);
    console.log("this.showFileFromComputer = ", this.showFileFromComputer);
    console.log("this.showLink = ", this.showLink);
    this.requestUpdate();
  }

  loadFiles(){
    if(this.loadingFiles || this.endOfFiles){
      console.log("previous file list call is still in progress or end of files list reached");
      return;
    }
    var startIndex = !this.listOfFiles.length?0:this.listOfFiles.length;
    var endIndex = startIndex + this.pageSize;
    var fileListApi = this.currentFileListApiUrl;
    this.loadingFiles = true;    
    this.getList(fileListApi, this.accessToken, startIndex, endIndex).then(
      (res) => this.processFileResults(res),
      (err) => {
        console.log("error in fetching file list", err);
        this.loadingFiles = false;
        this.requestUpdate();
      }
    );
  }

  processFileResults(result) {
    this.listOfFiles = Array.prototype.concat.apply(this.listOfFiles, JSON.parse(result.response));
    this.loadingFiles = false;

    if (this.isEndOfApiResults(result)) {
      this.endOfFiles = true;
    }

    this.requestUpdate();
  }

  load3DViews(){
    if(this.loading3DViews || this.endOf3DViews){
      console.log("previous 3d view list call is still in progress or end of 3d view list reached");
      return;
    }
    var startIndex = !this.listOf3DViews.length?0:this.listOf3DViews.length;
    var endIndex = startIndex + this.pageSize;
    this.loading3DViews = true;    
    this.getList(this.ThreeDimensionalViewListApiUrl, this.accessToken, startIndex, endIndex).then(
      (res) => this.process3DViewResults(res),
      (err) => {
        console.log("error in fetching 3d view list", err);
        this.loading3DViews = false;
        this.requestUpdate();
      }
    );
  }

  process3DViewResults(result) {
    this.listOf3DViews = Array.prototype.concat.apply(this.listOf3DViews, JSON.parse(result.response));
    this.loading3DViews = false;

    if (this.isEndOfApiResults(result)) {
      this.endOf3DViews = true;
    }

    this.requestUpdate();
  }

  load2DViews(){
    if(this.loading2DViews || this.endOf2DViews){
      console.log("previous 2d view list call is still in progress or end of 2d view list reached");
      return;
    }
    var startIndex = !this.listOf2DViews.length?0:this.listOf2DViews.length;
    var endIndex = startIndex + this.pageSize;
    this.loading2DViews = true;    
    this.getList(this.TwoDimensionalViewListApiUrl, this.accessToken, startIndex, endIndex).then(
      (res) => this.process2DViewResults(res),
      (err) => {
        console.log("error in fetching 2d view list", err);
        this.loading2DViews = false;
        this.requestUpdate();
      }
    );
  }

  process2DViewResults(result) {
    this.listOf2DViews = Array.prototype.concat.apply(this.listOf2DViews, JSON.parse(result.response));
    this.loading2DViews = false;

    if (this.isEndOfApiResults(result)) {
      this.endOf2DViews = true;
    }

    this.requestUpdate();
  }

  isEndOfApiResults(apiResult){
    var contentRange = apiResult.getResponseHeader("content-range");
    var totalRecords = parseInt( contentRange.substring(contentRange.indexOf("/") +1) );
    var rangeEnd = parseInt( contentRange.split("/")[0].split("-")[1] );

    //check if we reached end of list
    return rangeEnd == totalRecords -1 ? true : false;
  }

  toggleShortlistedItem(item, type){
    switch(type){
      case "FILE_FROM_CONNECT":
        if(this.shortlistedConnectFile && this.shortlistedConnectFile.id == item.id){
          this.shortlistedConnectFile = null;
        }else{
          this.shortlistedConnectFile = item;
        }
        break;
      case "2D_VIEW":
        if(this.shortlisted2DView && this.shortlisted2DView.id == item.id){
          this.shortlisted2DView = null;
        }else{
          this.shortlisted2DView = item;
        }
        break;
      case "3D_VIEW":
        if(this.shortlisted3DView && this.shortlisted3DView.id == item.id){
          this.shortlisted3DView = null;
        }else{
          this.shortlisted3DView = item;
        }
        break;
      case "FILE_FROM_COMPUTER":
        if(this.shortlistedComputerFile == item){
          this.shortlistedComputerFile = null;
        }else{
          this.shortlistedComputerFile = item;
        }
        break;
    }

    console.log("this.shortlistedConnectFile = ", this.shortlistedConnectFile);
    console.log("this.shortlisted2DView = ", this.shortlisted2DView);
    console.log("this.shortlisted3DView = ", this.shortlisted3DView);
    console.log("this.shortlistedComputerFile = ", this.shortlistedComputerFile);
    this.requestUpdate();
  }

  isShortlistedItem(item, type){
    var result = false;
    switch(type){
      case "FILE_FROM_CONNECT":
        if(this.shortlistedConnectFile && this.shortlistedConnectFile.id == item.id){
          result = true;
        }
        break;
      case "2D_VIEW":
        if(this.shortlisted2DView && this.shortlisted2DView.id == item.id){
          result = true;
        }
        break;
      case "3D_VIEW":
        if(this.shortlisted3DView && this.shortlisted3DView.id == item.id){
          result = true;
        }
        break;
      case "FILE_FROM_COMPUTER":
        if(this.shortlistedComputerFile == item){
          result = true;
        }
        break;
    }

    return result;
  }

  appendAccessToken(url){
    return url + "&accessToken=" + this.accessToken;
  }

  linkTextChanged(e){
    console.log("link text = ", e.target.value);
    this.linkText = e.target.value;
    this.linkTextError = this.linkText && this.linkText.length > 0 ? false : true;
    console.log("this.linkTextError = ", this.linkTextError);
    this.setLink();
  }

  linkUrlChanged(e){
    console.log("link URL = ", e.target.value);
    this.linkUrl = e.target.value;
    var result = true;
    if(this.linkUrl && this.linkUrl.length > 0){
      var re = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
      if (re.test(this.linkUrl)) { 
        console.log("valid url");
        result = false;
      }
    }

    this.linkUrlError = result;
    console.log("this.linkUrlError = ", this.linkUrlError);
    this.setLink();
  }

  setLink(){
    if(this.linkTextError || this.linkUrlError){
      this.shortlistedLink = null;
    }else{
      this.shortlistedLink = {
        displayText : this.linkText,
        url: this.linkUrl
      }
      console.log("linkShortListed = ", this.shortlistedLink);
    }

    this.requestUpdate();
  }

  dragEnterHandler(e){
    this.onDropTarget = true;
    this.multipleComputerFilesSelected = false;
    this.nonFileSelected = false;
    this.requestUpdate();
  }

  dragLeaveHandler(e){
    this.onDropTarget = false;
    this.requestUpdate();
  }

  dragOverHandler(e) {
    console.log('File(s) in drop zone'); 
    // Prevent default behavior (Prevent file from being opened)
    e.preventDefault();
  }

  dropHandler(e) {
    console.log('File(s) dropped');
    this.onDropTarget = false;
    // Prevent default behavior (Prevent file from being opened)
    e.preventDefault();
  
    var file = null;
    var isMultipleFiles = false;
    if (e.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (var i = 0; i < e.dataTransfer.items.length; i++) {
        // check if dropped items are files
        if (e.dataTransfer.items[i].kind === 'file' && !file) {
          if(e.dataTransfer.items[i].webkitGetAsEntry && e.dataTransfer.items[i].webkitGetAsEntry().isFile){
            file = e.dataTransfer.items[i].getAsFile();
          }
        }else if (e.dataTransfer.items[i].kind === 'file' && file){
          isMultipleFiles = true;
          break;
        }
      }
  } else if(e.dataTransfer.files){ 
      // Use DataTransfer interface to access the file(s)
        if(e.dataTransfer.files.length && e.dataTransfer.files.length == 1){
          console.log('selected file = ' + e.dataTransfer.files[0].name);
          file = e.dataTransfer.files[0];
        }else if(e.dataTransfer.files.length && e.dataTransfer.files.length > 1){
          file = e.dataTransfer.files[0];
          console.log("more than one file selected");
          isMultipleFiles = true;
        }
    }

    if(file){
      if(!isMultipleFiles){
        console.log('selected file = ' + file.name);
        this.shortlistedComputerFile = file;
        this.multipleComputerFilesSelected = false;
      }else{
        console.log("more than one file selected");
        this.shortlistedComputerFile = null;
        this.multipleComputerFilesSelected = true;
      }
    }else{
      console.log("no files selected");
      this.nonFileSelected = true;
    }

    this.requestUpdate();
  }

  launchNativeBrowser(){
    var fileBrowseButton = this.shadowRoot.querySelector("#browsed_file");
    fileBrowseButton.click();
  }

  computerFileSelectionChanged(e){
    console.log("file selction event =", e);
    if(e.target.files && e.target.files.length){
      this.multipleComputerFilesSelected = false;
      this.nonFileSelected = false;
      this.shortlistedComputerFile = e.target.files[0];
    }else{
      console.log("no files selected");
    }

    this.requestUpdate();
  }
 
  clearShortlistedComputerFile(){
    this.shortlistedComputerFile = null;
    this.requestUpdate();
  }


  isNonEmptyObject(obj){
    //console.log("obj=", obj);
    var result = false;
    try{
      obj = typeof obj == "object" ? obj : JSON.parse(obj);
      result = Object.keys(obj).length > 0;
    }catch(err){
      result = false;
      console.log("error in isNonEmptyObject check", err);
    }

    //console.log("isNonEmptyObject = ", result);
    return result;
  }
  
  firstUpdated(changedProps) {
    super.update(changedProps);
  }

  getList(apiUrl, accessToken, startIndex, endIndex){
    startIndex = startIndex || 0;
    endIndex = endIndex || startIndex + this.pageSize - 1;
    var headers = {
      "Content-type": "application/json",
      "Authorization": "Bearer " + (this.accessToken || accessToken),
      "Range": "items=" + startIndex +"-" + endIndex,
      "X-Range": "items=" + startIndex +"-" + endIndex
    };
    var promise = getRequestAsPromise("GET", apiUrl, headers, true);
    return promise;
  }

  getDetail(apiUrl, accessToken){
    var headers = {
      "Content-type": "application/json",
      "Authorization": "Bearer " + (this.accessToken || accessToken),
    };
    var promise = getRequestAsPromise("GET", apiUrl, headers);
    return promise;
  }

  updated(changedProps){
    super.updated(changedProps);
  }  

  async getStyles(){
    var resultIconStyle = "";

    resultIconStyle = await getRequestAsPromise("GET", "{{RESOURCE_DOMAIN}}/fonts/icon-font.css", null);
    var nodeIcons = document.createElement('style');
    nodeIcons.innerHTML = resultIconStyle;
    this.shadowRoot.querySelector("#defaultStyles").appendChild(nodeIcons);

    var nodeFontStyle = document.createElement('style');
    nodeFontStyle.innerHTML = `@font-face {
      font-family: 'tcw_svg';
      src: url("{{RESOURCE_DOMAIN}}/fonts/tcw_svg.eot");
      src: url("{{RESOURCE_DOMAIN}}/fonts/tcw_svg.eot#iefix") format("embedded-opentype"), 
      url("{{RESOURCE_DOMAIN}}/fonts/tcw_svg.ttf") format("truetype"),
      url("{{RESOURCE_DOMAIN}}/fonts/tcw_svg.woff") format("woff"), 
      url("{{RESOURCE_DOMAIN}}/fonts/tcw_svg.svg#tcw_svg") format("svg");
      font-weight: normal;
      font-style: normal; 
    }	`;
    window.document.head.appendChild(nodeFontStyle);

    this.stylesLoaded = true;
    this.requestUpdate();
  }

  async getCustomStyles(){
    if(this.customStyleUrl){
      var result = "";
      var customStylesFromUrlNode = document.createElement('style');
      result = await getRequestAsPromise("GET", this.customStyleUrl, null);
      customStylesFromUrlNode.innerHTML = result;
      this.shadowRoot.querySelector("#customStylesFromUrl").appendChild(customStylesFromUrlNode);
      this.requestUpdate();
    }
    
    if(this.customStyle){
      var customStylesNode = document.createElement('style');
      customStylesNode.innerHTML = this.customStyle;
      this.shadowRoot.querySelector("#customStyles").appendChild(customStylesNode);
      this.requestUpdate();
    }
  }

  showPickerDialog(){
    this.resetSelections(); //To reset al the selections made during lasttime the picker was launched
    this.launchDialog = true;
    this.requestUpdate();
  }

  setActiveTab(type){
    this.isShowFileFromConnect = false;
    this.isShowView = false;
    this.isShowLink = false;
    this.isShowFileFromComputer = false;
    
    switch(type){
      case 'FILE_FROM_CONNECT':
        this.isShowFileFromConnect = true;
        break;
      case 'VIEW':
        this.isShowView = true;
        break;
      case 'LINK':
        this.isShowLink = true;
        break;
      case 'FILE_FROM_COMPUTER':
        this.isShowFileFromComputer = true;
        break;
      default:
        if(this.showFileFromConnect){
          this.isShowFileFromConnect = true;
        }else if(this.show3DView || this.show2DView){
          this.isShowView = true;
        }else if(this.showLink){
          this.isShowLink = true;
        }else if(this.showFileFromComputer){
          this.isShowFileFromComputer = true;
        }else{
          this.isShowFileFromConnect = true;
        }
        
    }

    this.requestUpdate();
  }

  setActiveViewTab(type){
    this.isShow2DView = false;
    this.isShow3DView = false;
    
    switch(type){
      case '2D_VIEW':
        this.isShow2DView = true;
        break;
      case '3D_VIEW':
        this.isShow3DView = true;
        break;
      default:
        if(this.show3DView && !this.show2DView){
          this.isShow3DView = true;
        }else if(!this.show3DView && this.show2DView){
          this.isShow2DView = true;
        }else{
          this.isShow3DView = true;
        }
    }

    this.requestUpdate();
  }
  
  handleFileClick(item, e){
    e.stopPropagation(); 
    if (item.type == 'FILE') {
      this.toggleShortlistedItem(item, 'FILE_FROM_CONNECT')
    }else{
      this.addToFolders(item); 
      this.reloadFileList(item.id);
    }
  }
}

console.log("is attachment-picker already registered = ", !!customElements.get('attachment-picker'));
if(!customElements.get('attachment-picker')){
  customElements.define('attachment-picker', AttachmentPicker);
  console.log("is attachment-picker successfully registered = ", !!customElements.get('attachment-picker'));
}

export default AttachmentPicker;
window.AttachmentPicker= AttachmentPicker;